import React, { Component } from 'react';
import AddressCelebrityData from './addressCelebrityData';

import commonUtil from '../../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();

class AddressCelebrityDataContainerWap extends Component {
  render() {
    const props = this.props;
    const addressDataHtmlFn = props.addressDataHtmlFn;
    const numberOfAddresses = props.numberOfAddresses;
    const celebrityOptions = props.celebrityOptions;
    const addressObject = props.addressObject;
    const address = props.address;
    const labels = props.labels;

    return (
      <div>
        {/* // TODO: Componentization this atom. Is reusable in multiple places */}
        {/* {
          channel === 'wap' && (<div className="boxHeader">
            <div>
              <h2>Direcciones de entrega</h2>
              <span
                onClick={this.props.closeEditAndNewAddressSection}
                className="close"
              >
                <span style={{ marginRight: 7 }}>Cerrar</span><i className="icon-tache2" />
              </span>
            </div>
          </div>)
        } */}

        <AddressCelebrityData
          openAddressWap={this.props.openAddressWap}
          numberOfAddresses={numberOfAddresses}
          addressDataHtmlFn={addressDataHtmlFn}
          celebrityOptions={celebrityOptions}
          addressObject={addressObject}
          address={address}
          labels={labels}
          HandleDefaultAddresId={this.props.HandleDefaultAddresId}
          defaultAddress={this.props.defaultAddress}
          index={this.props.index}
        />

      </div>
    );
  }
}

export default AddressCelebrityDataContainerWap;
